// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner_banner__Tul5Q","title":"banner_title__1d7nV"};